import { conversationsApiBaseUrl } from '../api.js';
/**
 * Fetch reply templates (`GET /api/templates`). Mirrors the reply composer's
 * private `fetchTemplates`; shares the same `['templates']` react-query key so
 * the cache entry is reused across the composer + bulk dialogs. Fail-soft: `[]`.
 */
export async function fetchTemplates() {
    const r = await fetch(`${conversationsApiBaseUrl()}/api/templates`, {
        credentials: 'include',
    });
    if (!r.ok)
        return [];
    const data = (await r.json());
    return data.items ?? [];
}
/**
 * Fetch the pipeline catalog for the bulk «Пайплайн» picker via
 * `GET /api/pipelines/basic` — a `conversation.reply`-gated `{key,name,enabled}`
 * projection. We deliberately do NOT use `GET /api/pipelines` here: that route
 * is `pipelines.read` (owner/supervisor only), so a `member` admin — who IS
 * allowed to run the bulk pipeline action — would get a 403 and a silently empty
 * picker. Returns a `{ items: [...] }` envelope; tolerate a bare array
 * defensively. Fail-soft: `[]` on error.
 */
export async function fetchPipelines() {
    const r = await fetch(`${conversationsApiBaseUrl()}/api/pipelines/basic`, {
        credentials: 'include',
    });
    if (!r.ok)
        return [];
    const data = (await r.json());
    const rows = Array.isArray(data) ? data : (data.items ?? []);
    return rows.map((p) => ({ key: p.key, name: p.name, enabled: p.enabled }));
}
//# sourceMappingURL=bulk-data.js.map